"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlackUserFromUserId = exports.getSlackUserFromEmail = exports.GET_SLACK_USER = void 0;

var _avlComponents = require("@availabs/avl-components");

var _utils = require("./utils");

var GET_SLACK_USER = "AMS::GET_SLACK_USER";
exports.GET_SLACK_USER = GET_SLACK_USER;

var getSlackUserFromEmail = function getSlackUserFromEmail(email) {
  return function (dispatch, getState) {
    var _Config = (0, _utils.Config)(),
        SLACK_KEY = _Config.SLACK_KEY;

    if (SLACK_KEY) {
      var URL = "https://slack.com/api/users.lookupByEmail";
      var options = {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        },
        body: "token=".concat(encodeURIComponent(SLACK_KEY), "&email=").concat(encodeURIComponent(email))
      };
      return fetch(URL, options).then(function (res) {
        if (res.ok) {
          return res.json();
        }

        dispatch((0, _avlComponents.sendSystemMessage)("There was a network error."));
      }).then(function (res) {
        if (res.ok) {
          dispatch({
            type: GET_SLACK_USER,
            slacker: res.user
          });
        } else {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.getSlackUserFromEmail = getSlackUserFromEmail;

var getSlackUserFromUserId = function getSlackUserFromUserId(userId) {
  return function (dispatch, getState) {
    var _Config2 = (0, _utils.Config)(),
        SLACK_KEY = _Config2.SLACK_KEY;

    if (SLACK_KEY) {// const URL = `https://slack.com/api/users.lookupByEmail`;
      // const options = {
      //   method: "POST",
      //   headers: {
      //     "Content-type": "application/x-www-form-urlencoded"
      //   },
      //   body: `token=${ encodeURIComponent(SLACK_KEY) }&email=${ encodeURIComponent(email) }`
      // }
      // return fetch(URL, options)
      //   .then(res => {
      //     if (res.ok) {
      //       return res.json();
      //     }
      //     dispatch(sendSystemMessage("There was a network error."));
      //   })
      //   .then(res => {
      //     if (res.ok) {
      //       dispatch({
      //         type: GET_SLACK_USER,
      //         slacker: res.user
      //       });
      //     }
      //     else {
      //       dispatch(sendSystemMessage(res.error));
      //     }
      //   })
    } else {
      return Promise.resolve();
    }
  };
};

exports.getSlackUserFromUserId = getSlackUserFromUserId;